<template>
  <div>
    <div class="px-4">
      <div class="body p-4">
        <span class="text-primary h2 d-flex align-items-center">
          <button
            @click="$router.push('/cliente/nfse')"
            class="btn font-weight-bold btn-primary text-white btn-shadow me-3"
            v-prevent-click
          >
            <i class="fa fa-arrow-left"></i>
          </button>
          <span class="text-gray"> {{ pageTitle }}</span>
        </span>

        <div
          v-if="configActive === false"
          class="alert alert-warning mt-4 mb-0"
          role="alert"
        >
          Configuração aguardando ativação por um administrador. Emissões estarão bloqueadas até a ativação.
        </div>

        <div v-if="configIncomplete" class="alert alert-danger mt-4 mb-0" role="alert">
          A configuração fiscal da NFS-e está incompleta — não é possível emitir.
          <router-link to="/cliente/nfse/config" class="alert-link">
            Revisar configuração fiscal
          </router-link>
        </div>

        <div v-if="sourceError" class="alert alert-danger mt-4 mb-0" role="alert">
          <strong>Erro na emissão original:</strong> {{ sourceError }}
          <div class="mt-1">Corrija os dados abaixo e emita novamente — será gerada uma nova NFS-e.</div>
        </div>

        <div v-if="legacyTotTrib" class="alert alert-info mt-4 mb-0" role="alert">
          A nota original informava uma alíquota total única de {{ legacyTotTrib }}%. O novo layout
          exige a divisão em tributos federais, estaduais e municipais — preencha os três campos
          abaixo.
        </div>

        <div v-if="submitError" class="alert alert-danger mt-4 mb-0" role="alert">
          {{ submitError.message }}
          <div class="mt-2" v-if="submitErrorCta">
            <router-link :to="submitErrorCta.to" class="alert-link">
              {{ submitErrorCta.label }}
            </router-link>
          </div>
        </div>

        <div class="card p-4 mt-4">
          <div class="p-2">
            <form @submit.prevent="submitForm" autocomplete="off">
              <div class="row text-start">
                <div class="col-12">
                  <h5 class="text-gray font-weight-light mb-3">
                    Emiss&atilde;o
                  </h5>
                </div>
                <div class="col-lg-2 col-md-4 col-sm-12 text-primary mb-4">
                  <label for="input-serie" class="form-label mb-2">
                    S&eacute;rie
                  </label>
                  <input
                    type="text"
                    id="input-serie"
                    class="form-control"
                    placeholder="1"
                    v-model="model.serie"
                  />
                </div>
                <div
                  v-if="proximoNDps !== null"
                  class="col-lg-2 col-md-4 col-sm-12 text-primary mb-4"
                >
                  <label for="input-n-dps" class="form-label mb-2">
                    N&uacute;mero da NF
                  </label>
                  <input
                    type="text"
                    id="input-n-dps"
                    class="form-control"
                    disabled
                    :value="proximoNDps"
                  />
                  <div class="form-text">Previsão — pode mudar se houver outra emissão antes</div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-12 text-primary mb-4">
                  <label for="input-dcompet" class="form-label mb-2">
                    Compet&ecirc;ncia
                  </label>
                  <input
                    type="date"
                    id="input-dcompet"
                    class="form-control"
                    v-model="model.dCompet"
                  />
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 text-primary mb-4">
                  <label class="form-label mb-2">Munic&iacute;pio de Emiss&atilde;o</label>
                  <v-select
                    v-model="selectedMunicipioEmissao"
                    :options="filteredMunicipiosEmissao"
                    :get-option-label="(m) => `${m.nome} (${m.uf})`"
                    :filterable="false"
                    @search="onMunicipioEmissaoSearch"
                    placeholder="Digite o nome da cidade"
                    no-drop-on-empty
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        v-bind="attributes"
                        v-on="events"
                        autocomplete="nfse-municipio"
                      />
                    </template>
                    <template #no-options="{ search }">
                      <span v-if="!search || search.length < 2">
                        Digite o nome da cidade para pesquisar
                      </span>
                      <span v-else>Nenhuma cidade encontrada</span>
                    </template>
                  </v-select>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 text-primary mb-4">
                  <label class="form-label mb-2">Munic&iacute;pio de Presta&ccedil;&atilde;o</label>
                  <v-select
                    v-model="selectedMunicipioPrestacao"
                    :options="filteredMunicipiosPrestacao"
                    :get-option-label="(m) => `${m.nome} (${m.uf})`"
                    :filterable="false"
                    @search="onMunicipioPrestacaoSearch"
                    placeholder="Padrão: igual ao de emissão"
                    no-drop-on-empty
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        v-bind="attributes"
                        v-on="events"
                        autocomplete="nfse-municipio-prestacao"
                      />
                    </template>
                    <template #no-options="{ search }">
                      <span v-if="!search || search.length < 2">
                        Digite o nome da cidade para pesquisar
                      </span>
                      <span v-else>Nenhuma cidade encontrada</span>
                    </template>
                  </v-select>
                </div>

                <div class="w-100"></div>
                <div class="col-12">
                  <h5 class="text-gray font-weight-light mb-3">
                    Servi&ccedil;o
                  </h5>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-12 text-primary mb-4">
                  <label for="input-service-item" class="form-label mb-2">
                    Servi&ccedil;o*
                  </label>
                  <select
                    id="input-service-item"
                    class="form-select"
                    v-model="model.serviceItemId"
                    required
                  >
                    <option value="" disabled>Selecione um serviço</option>
                    <option
                      v-for="s in services"
                      :key="s.id"
                      :value="s.id"
                      :disabled="isServiceIncomplete(s)"
                    >
                      {{ s.name }} ({{ serviceFiscalLabel(s) }}){{ isServiceIncomplete(s) ? " — cadastro incompleto" : "" }}
                    </option>
                  </select>
                  <div v-if="services.length === 0 && !loadingServices" class="form-text text-warning mt-1">
                    Nenhum serviço cadastrado.
                    <router-link to="/cliente/nfse/servicos/novo">Cadastrar serviço</router-link>
                  </div>
                  <div v-else-if="hasIncompleteService" class="form-text text-warning mt-1">
                    Alguns serviços estão com o cadastro fiscal incompleto e aparecem desabilitados.
                    <router-link to="/cliente/nfse/servicos">Completar cadastro</router-link>
                  </div>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-12 text-primary mb-4">
                  <label for="input-xdescserv" class="form-label mb-2">
                    Descri&ccedil;&atilde;o do servi&ccedil;o na nota
                  </label>
                  <input
                    type="text"
                    id="input-xdescserv"
                    class="form-control"
                    placeholder="Padrão: descrição do serviço cadastrado"
                    v-model="model.xDescServ"
                  />
                </div>

                <div class="w-100"></div>
                <div class="col-12">
                  <h5 class="text-gray font-weight-light mb-3">Valores</h5>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12 text-primary mb-4">
                  <label for="input-service-value" class="form-label mb-2">
                    Valor do servi&ccedil;o*
                  </label>
                  <input
                    type="number"
                    min="0.01"
                    max="9999999.99"
                    step="0.01"
                    id="input-service-value"
                    class="form-control"
                    placeholder="1500.00"
                    v-model="model.valores.valorServico"
                    required
                  />
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12 text-primary mb-4">
                  <label for="input-tribissqn" class="form-label mb-2">
                    Tributa&ccedil;&atilde;o do ISSQN*
                  </label>
                  <select
                    id="input-tribissqn"
                    class="form-select"
                    v-model="model.valores.tribISSQN"
                    required
                  >
                    <option value="1">1 — Tributável</option>
                    <option
                      value="2"
                      :disabled="!allowTribIssqnEspecial"
                      :title="tributacaoIndisponivelMessage"
                    >
                      2 — Imunidade
                    </option>
                    <option
                      value="3"
                      :disabled="!allowTribIssqnEspecial"
                      :title="tributacaoIndisponivelMessage"
                    >
                      3 — Exportação de serviço
                    </option>
                    <option
                      value="4"
                      :disabled="!allowTribIssqnEspecial"
                      :title="tributacaoIndisponivelMessage"
                    >
                      4 — Não incidência
                    </option>
                  </select>
                  <div v-if="!allowTribIssqnEspecial" class="form-text">
                    {{ tributacaoIndisponivelMessage }}
                    <router-link to="/cliente/nfse/config">
                      Ajuste em Configurações de NFS-e.
                    </router-link>
                  </div>
                </div>
                <div
                  v-if="isImunidade"
                  class="col-lg-6 col-md-12 col-sm-12 text-primary mb-4"
                >
                  <label for="input-tpimunidade" class="form-label mb-2">
                    Tipo de imunidade*
                  </label>
                  <select
                    id="input-tpimunidade"
                    class="form-select"
                    :class="{ 'is-invalid': !!tpImunidadeError }"
                    v-model="model.valores.tpImunidade"
                    @invalid.prevent="tpImunidadeError = 'Selecione o tipo de imunidade.'"
                    required
                  >
                    <option value="" disabled>Selecione o tipo de imunidade</option>
                    <option
                      v-for="option in tpImunidadeOptions"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ option.value }} — {{ option.label }}
                    </option>
                  </select>
                  <div v-if="tpImunidadeError" class="invalid-feedback d-block">
                    {{ tpImunidadeError }}
                  </div>
                </div>
                <div
                  v-if="isExportacao"
                  class="col-lg-6 col-md-12 col-sm-12 text-primary mb-4"
                >
                  <label class="form-label mb-2">
                    Pa&iacute;s do resultado da exporta&ccedil;&atilde;o
                  </label>
                  <v-select
                    v-model="selectedPaisResultado"
                    :options="paisesExterior"
                    :get-option-label="(p) => `${p.nome} (${p.codigo})`"
                    placeholder="Opcional — deixe vazio se já indicado pelo tomador"
                  />
                  <div class="form-text">
                    Informe apenas quando o resultado ocorre em país diferente do
                    tomador.
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12 text-primary mb-4">
                  <label for="input-tpretissqn" class="form-label mb-2">
                    Reten&ccedil;&atilde;o ISSQN*
                  </label>
                  <select
                    id="input-tpretissqn"
                    class="form-select"
                    v-model="model.valores.tpRetISSQN"
                    :disabled="isTribIssqnSemRetencao"
                    required
                  >
                    <option value="" disabled>Selecione</option>
                    <option value="1">1 — Não retido</option>
                    <option value="2">2 — Retido pelo Tomador</option>
                    <option value="3">3 — Retido pelo Intermediário</option>
                  </select>
                  <div v-if="isTribIssqnSemRetencao" class="form-text">
                    {{ tribIssqnLabel }} do ISSQN não admite retenção.
                  </div>
                </div>
                <div class="w-100"></div>
                <div v-if="showTotTribSN" class="col-lg-3 col-md-6 col-sm-12 text-primary mb-4">
                  <label for="input-ptottribsn" class="form-label mb-2">
                    Al&iacute;quota total de tributos (%)*
                  </label>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    id="input-ptottribsn"
                    class="form-control"
                    placeholder="Ex: 6.00"
                    v-model="model.valores.pTotTribSN"
                    required
                  />
                  <div class="form-text">Simples Nacional — faixa PGDAS</div>
                </div>
                <template v-else-if="showTotTribBreakdown">
                  <div class="col-lg-3 col-md-6 col-sm-12 text-primary mb-4">
                    <label for="input-ptottribfed" class="form-label mb-2">
                      Tributos federais (%)*
                    </label>
                    <input
                      type="number"
                      min="0"
                      max="100"
                      step="0.01"
                      id="input-ptottribfed"
                      class="form-control"
                      placeholder="Ex: 2.00"
                      v-model="model.valores.pTotTribFed"
                      required
                    />
                  </div>
                  <div class="col-lg-3 col-md-6 col-sm-12 text-primary mb-4">
                    <label for="input-ptottribest" class="form-label mb-2">
                      Tributos estaduais (%)*
                    </label>
                    <input
                      type="number"
                      min="0"
                      max="100"
                      step="0.01"
                      id="input-ptottribest"
                      class="form-control"
                      placeholder="Ex: 2.00"
                      v-model="model.valores.pTotTribEst"
                      required
                    />
                  </div>
                  <div class="col-lg-3 col-md-6 col-sm-12 text-primary mb-4">
                    <label for="input-ptottribmun" class="form-label mb-2">
                      Tributos municipais (%)*
                    </label>
                    <input
                      type="number"
                      min="0"
                      max="100"
                      step="0.01"
                      id="input-ptottribmun"
                      class="form-control"
                      placeholder="Ex: 2.00"
                      v-model="model.valores.pTotTribMun"
                      required
                    />
                  </div>
                </template>
                <div v-else-if="isMeiTotTrib" class="col-lg-6 col-md-6 col-sm-12 text-primary mb-4">
                  <label class="form-label mb-2">
                    Al&iacute;quota total de tributos
                  </label>
                  <input type="text" class="form-control" disabled value="Não se aplica (MEI)" />
                  <div class="form-text">
                    MEI — a nota é emitida com o indicador de tributos, sem percentual.
                  </div>
                </div>

                <!-- comExt: exigido na exportação e sempre que há parte no exterior -->
                <template v-if="showComExt">
                  <div class="w-100"></div>
                  <div class="col-12">
                    <h5 class="text-gray font-weight-light mb-1">
                      Com&eacute;rcio exterior
                    </h5>
                    <p class="form-text mt-0 mb-3">
                      Obrigat&oacute;rio por causa de: {{ comExtMotivo }}.
                    </p>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4">
                    <label for="input-mdprestacao" class="form-label mb-2">
                      Modo de presta&ccedil;&atilde;o*
                    </label>
                    <select
                      id="input-mdprestacao"
                      class="form-select"
                      v-model="model.comExt.mdPrestacao"
                      required
                    >
                      <option value="" disabled>Selecione</option>
                      <option
                        v-for="option in mdPrestacaoOptions"
                        :key="option.value"
                        :value="option.value"
                      >
                        {{ option.value }} — {{ option.label }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4">
                    <label for="input-vincprest" class="form-label mb-2">
                      V&iacute;nculo com o prestador*
                    </label>
                    <select
                      id="input-vincprest"
                      class="form-select"
                      v-model="model.comExt.vincPrest"
                      required
                    >
                      <option
                        v-for="option in vincPrestOptions"
                        :key="option.value"
                        :value="option.value"
                      >
                        {{ option.value }} — {{ option.label }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4">
                    <label class="form-label mb-2">Moeda*</label>
                    <template v-if="!moedaManual">
                      <v-select
                        v-model="selectedMoeda"
                        :options="moedasSugeridas"
                        :get-option-label="(m) => `${m.alfa} — ${m.nome}`"
                        placeholder="Código ou nome da moeda"
                      >
                        <template #option="m">
                          <strong>{{ m.alfa }}</strong> — {{ m.nome }}
                        </template>
                        <template #selected-option="m">
                          <strong>{{ m.alfa }}</strong> — {{ m.nome }}
                        </template>
                      </v-select>
                      <div class="form-text">
                        Não encontrou a moeda?
                        <button
                          type="button"
                          class="btn btn-link btn-sm p-0 align-baseline"
                          @click="toggleMoedaManual(true)"
                        >
                          Informar o código manualmente.
                        </button>
                      </div>
                    </template>
                    <template v-else>
                      <input
                        type="text"
                        inputmode="numeric"
                        maxlength="3"
                        id="input-tpmoeda"
                        class="form-control"
                        placeholder="840"
                        v-model="model.comExt.tpMoeda"
                        @input="model.comExt.tpMoeda = onlyDigits(model.comExt.tpMoeda)"
                        required
                      />
                      <div class="form-text">
                        C&oacute;digo de 3 d&iacute;gitos da tabela de moedas do Banco
                        Central.
                        <button
                          type="button"
                          class="btn btn-link btn-sm p-0 align-baseline"
                          @click="toggleMoedaManual(false)"
                        >
                          Voltar &agrave; busca por nome.
                        </button>
                      </div>
                    </template>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4">
                    <label for="input-vservmoeda" class="form-label mb-2">
                      Valor na moeda estrangeira*
                    </label>
                    <input
                      type="number"
                      min="0.01"
                      max="9999999.99"
                      step="0.01"
                      id="input-vservmoeda"
                      class="form-control"
                      placeholder="1500.00"
                      v-model="model.comExt.vServMoeda"
                      required
                    />
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4">
                    <label for="input-mecafcomexp" class="form-label mb-2">
                      Mecanismo de apoio — prestador*
                    </label>
                    <select
                      id="input-mecafcomexp"
                      class="form-select"
                      v-model="model.comExt.mecAFComexP"
                      required
                    >
                      <option
                        v-for="option in mecAFComexPOptions"
                        :key="option.value"
                        :value="option.value"
                      >
                        {{ option.value }} — {{ option.label }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4">
                    <label for="input-mecafcomext" class="form-label mb-2">
                      Mecanismo de apoio — tomador*
                    </label>
                    <select
                      id="input-mecafcomext"
                      class="form-select"
                      v-model="model.comExt.mecAFComexT"
                      required
                    >
                      <option
                        v-for="option in mecAFComexTOptions"
                        :key="option.value"
                        :value="option.value"
                      >
                        {{ option.value }} — {{ option.label }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4">
                    <label for="input-movtempbens" class="form-label mb-2">
                      Movimento tempor&aacute;rio de bens*
                    </label>
                    <select
                      id="input-movtempbens"
                      class="form-select"
                      v-model="model.comExt.movTempBens"
                      required
                    >
                      <option
                        v-for="option in movTempBensOptions"
                        :key="option.value"
                        :value="option.value"
                      >
                        {{ option.value }} — {{ option.label }}
                      </option>
                    </select>
                  </div>
                  <div
                    v-if="movTempBensComDI"
                    class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4"
                  >
                    <label for="input-ndi" class="form-label mb-2">
                      N&uacute;mero da Declara&ccedil;&atilde;o de Importa&ccedil;&atilde;o*
                    </label>
                    <input
                      type="text"
                      maxlength="12"
                      id="input-ndi"
                      class="form-control"
                      v-model="model.comExt.nDI"
                      required
                    />
                    <div class="form-text">At&eacute; 12 caracteres</div>
                  </div>
                  <div
                    v-if="movTempBensComRE"
                    class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4"
                  >
                    <label for="input-nre" class="form-label mb-2">
                      N&uacute;mero da Declara&ccedil;&atilde;o de Exporta&ccedil;&atilde;o*
                    </label>
                    <input
                      type="text"
                      maxlength="12"
                      id="input-nre"
                      class="form-control"
                      v-model="model.comExt.nRE"
                      required
                    />
                    <div class="form-text">Exatamente 12 caracteres</div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4">
                    <label for="input-mdic" class="form-label mb-2">
                      Compartilhar com o MDIC*
                    </label>
                    <select
                      id="input-mdic"
                      class="form-select"
                      v-model="model.comExt.mdic"
                      required
                    >
                      <option
                        v-for="option in mdicOptions"
                        :key="option.value"
                        :value="option.value"
                      >
                        {{ option.value }} — {{ option.label }}
                      </option>
                    </select>
                  </div>
                </template>

                <div class="w-100"></div>
                <div class="col-12 d-flex align-items-center mb-3">
                  <h5 class="text-gray font-weight-light mb-0 me-4">Tomador</h5>
                  <div class="btn-group btn-group-sm" role="group">
                    <button
                      type="button"
                      :class="['btn', tomadorMode === 'cadastrado' ? 'btn-primary' : 'btn-outline-primary']"
                      @click="tomadorMode = 'cadastrado'"
                    >
                      Cadastrado
                    </button>
                    <button
                      type="button"
                      :class="['btn', tomadorMode === 'avulso' ? 'btn-primary' : 'btn-outline-primary']"
                      @click="tomadorMode = 'avulso'"
                    >
                      Avulso
                    </button>
                  </div>
                  <!-- Cliente cadastrado é sempre nacional: o cadastro não
                       guarda NIF nem endereço no exterior. -->
                  <div
                    v-if="tomadorMode === 'avulso'"
                    class="btn-group btn-group-sm ms-3"
                    role="group"
                  >
                    <button
                      type="button"
                      :class="['btn', tomadorLocal === 'nacional' ? 'btn-primary' : 'btn-outline-primary']"
                      @click="tomadorLocal = 'nacional'"
                    >
                      No Brasil
                    </button>
                    <button
                      type="button"
                      :class="['btn', tomadorLocal === 'exterior' ? 'btn-primary' : 'btn-outline-primary']"
                      @click="tomadorLocal = 'exterior'"
                    >
                      No exterior
                    </button>
                  </div>
                </div>

                <!-- Tomador cadastrado -->
                <template v-if="tomadorMode === 'cadastrado'">
                  <div class="col-lg-6 col-md-8 col-sm-12 text-primary mb-4">
                    <label for="input-customer-id" class="form-label mb-2">
                      Cliente*
                    </label>
                    <select
                      id="input-customer-id"
                      class="form-select"
                      v-model="model.customerId"
                    >
                      <option value="" disabled>Selecione um cliente</option>
                      <option
                        v-for="c in customers"
                        :key="c.id"
                        :value="c.id"
                      >
                        {{ c.nome }} — {{ c.documento || "sem doc." }}
                      </option>
                    </select>
                    <div v-if="customers.length === 0 && !loadingCustomers" class="form-text text-warning mt-1">
                      Nenhum cliente cadastrado.
                      <router-link to="/cliente/nfse/clientes/novo">Cadastrar cliente</router-link>
                    </div>
                  </div>
                </template>

                <!-- Tomador avulso -->
                <template v-else>
                  <div
                    v-if="!tomadorExterior"
                    class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4"
                  >
                    <label for="input-taker-document" class="form-label mb-2">
                      CPF/CNPJ*
                    </label>
                    <input
                      type="text"
                      inputmode="numeric"
                      maxlength="14"
                      id="input-taker-document"
                      class="form-control"
                      placeholder="Apenas dígitos"
                      v-model="model.tomador.documento"
                      @input="model.tomador.documento = onlyDigits(model.tomador.documento)"
                    />
                  </div>
                  <template v-else>
                    <div class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4">
                      <label for="input-taker-id-mode" class="form-label mb-2">
                        Identifica&ccedil;&atilde;o fiscal*
                      </label>
                      <select
                        id="input-taker-id-mode"
                        class="form-select"
                        v-model="tomadorIdMode"
                      >
                        <option value="nif">NIF</option>
                        <option value="cNaoNIF">Sem NIF</option>
                      </select>
                    </div>
                    <div
                      v-if="tomadorIdMode === 'nif'"
                      class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4"
                    >
                      <label for="input-taker-nif" class="form-label mb-2">
                        NIF*
                      </label>
                      <input
                        type="text"
                        id="input-taker-nif"
                        class="form-control"
                        placeholder="Número de identificação fiscal no exterior"
                        v-model="model.tomador.nif"
                      />
                    </div>
                    <div v-else class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4">
                      <label for="input-taker-cnaonif" class="form-label mb-2">
                        Motivo da aus&ecirc;ncia de NIF*
                      </label>
                      <select
                        id="input-taker-cnaonif"
                        class="form-select"
                        v-model="model.tomador.cNaoNIF"
                      >
                        <option value="" disabled>Selecione</option>
                        <option
                          v-for="option in cNaoNIFOptions"
                          :key="option.value"
                          :value="option.value"
                        >
                          {{ option.value }} — {{ option.label }}
                        </option>
                      </select>
                    </div>
                  </template>
                  <div class="col-lg-8 col-md-6 col-sm-12 text-primary mb-4">
                    <label for="input-taker-name" class="form-label mb-2">
                      Nome*
                    </label>
                    <input
                      type="text"
                      id="input-taker-name"
                      class="form-control"
                      placeholder="Empresa Tomadora Ltda"
                      v-model="model.tomador.nome"
                    />
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4">
                    <label for="input-taker-email" class="form-label mb-2">
                      E-mail
                    </label>
                    <input
                      type="email"
                      id="input-taker-email"
                      class="form-control"
                      placeholder="financeiro@tomadora.com.br"
                      v-model="model.tomador.email"
                    />
                  </div>
                  <div class="col-lg-3 col-md-6 col-sm-12 text-primary mb-4">
                    <label for="input-taker-fone" class="form-label mb-2">
                      Telefone
                    </label>
                    <input
                      type="text"
                      inputmode="numeric"
                      maxlength="11"
                      id="input-taker-fone"
                      class="form-control"
                      placeholder="DDD + número, só dígitos"
                      v-model="model.tomador.fone"
                      @input="model.tomador.fone = onlyDigits(model.tomador.fone)"
                    />
                  </div>

                  <div class="col-12">
                    <h5 class="text-gray font-weight-light mb-3">
                      Endere&ccedil;o do tomador
                    </h5>
                  </div>
                  <div
                    v-if="!tomadorExterior"
                    class="col-lg-3 col-md-6 col-sm-12 text-primary mb-4"
                  >
                    <label for="input-cep" class="form-label mb-2">CEP*</label>
                    <input
                      type="text"
                      maxlength="9"
                      id="input-cep"
                      class="form-control"
                      placeholder="01310-100"
                      v-model="model.tomador.endereco.cep"
                      @input="onCepInput"
                    />
                    <div v-if="loadingCep" class="form-text">Buscando endereço...</div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 text-primary mb-4">
                    <label for="input-street" class="form-label mb-2">
                      Logradouro*
                    </label>
                    <input
                      type="text"
                      id="input-street"
                      class="form-control"
                      placeholder="Rua das Flores"
                      v-model="model.tomador.endereco.logradouro"
                    />
                  </div>
                  <div class="col-lg-2 col-md-6 col-sm-12 text-primary mb-4">
                    <label for="input-number" class="form-label mb-2">
                      N&uacute;mero*
                    </label>
                    <input
                      type="text"
                      id="input-number"
                      class="form-control"
                      placeholder="123"
                      v-model="model.tomador.endereco.numero"
                    />
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4">
                    <label for="input-complemento" class="form-label mb-2">
                      Complemento
                    </label>
                    <input
                      type="text"
                      id="input-complemento"
                      class="form-control"
                      placeholder="Sala 5"
                      v-model="model.tomador.endereco.complemento"
                    />
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4">
                    <label for="input-neighborhood" class="form-label mb-2">
                      Bairro*
                    </label>
                    <input
                      type="text"
                      id="input-neighborhood"
                      class="form-control"
                      placeholder="Centro"
                      v-model="model.tomador.endereco.bairro"
                    />
                  </div>
                  <div
                    v-if="!tomadorExterior"
                    class="col-lg-6 col-md-6 col-sm-12 text-primary mb-4"
                  >
                    <label class="form-label mb-2">Munic&iacute;pio*</label>
                    <v-select
                      v-model="selectedMunicipioTomador"
                      :options="filteredMunicipiosTomador"
                      :get-option-label="(m) => `${m.nome} (${m.uf})`"
                      :filterable="false"
                      @search="onMunicipioTomadorSearch"
                      placeholder="Digite o nome da cidade"
                      no-drop-on-empty
                    >
                      <template #search="{ attributes, events }">
                        <input
                          class="vs__search"
                          v-bind="attributes"
                          v-on="events"
                          autocomplete="nfse-municipio"
                        />
                      </template>
                      <template #no-options="{ search }">
                        <span v-if="!search || search.length < 2">
                          Digite o nome da cidade para pesquisar
                        </span>
                        <span v-else>Nenhuma cidade encontrada</span>
                      </template>
                    </v-select>
                  </div>
                  <template v-if="tomadorExterior">
                    <div class="col-lg-4 col-md-6 col-sm-12 text-primary mb-4">
                      <label class="form-label mb-2">Pa&iacute;s*</label>
                      <v-select
                        v-model="selectedPaisTomador"
                        :options="paisesExterior"
                        :get-option-label="(p) => `${p.nome} (${p.codigo})`"
                        placeholder="Selecione o país"
                      />
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12 text-primary mb-4">
                      <label for="input-taker-postal" class="form-label mb-2">
                        C&oacute;digo postal*
                      </label>
                      <input
                        type="text"
                        id="input-taker-postal"
                        class="form-control"
                        placeholder="94105"
                        v-model="model.tomador.endereco.codigoPostal"
                      />
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12 text-primary mb-4">
                      <label for="input-taker-city" class="form-label mb-2">
                        Cidade*
                      </label>
                      <input
                        type="text"
                        id="input-taker-city"
                        class="form-control"
                        placeholder="San Francisco"
                        v-model="model.tomador.endereco.cidade"
                      />
                    </div>
                    <div class="col-lg-2 col-md-6 col-sm-12 text-primary mb-4">
                      <label for="input-taker-region" class="form-label mb-2">
                        Estado/prov&iacute;ncia*
                      </label>
                      <input
                        type="text"
                        id="input-taker-region"
                        class="form-control"
                        placeholder="CA"
                        v-model="model.tomador.endereco.estadoProvinciaRegiao"
                      />
                    </div>
                  </template>
                </template>
              </div>
              <span class="text-center mt-4">
                <button
                  type="submit"
                  class="btn px-4 font-weight-bold btn-primary text-white btn-shadow"
                  :disabled="loaderActive || !canIssue"
                >
                  <span class="mx-4" v-if="!loaderActive">Emitir</span>
                  <span class="mx-4" v-else>Aguarde...</span>
                </button>
              </span>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "vue-select/dist/vue-select.css";
import municipios from "@/data/nfse/municipios.json";
import paises from "@/data/nfse/paises.json";
import {
  MD_PRESTACAO_OPTIONS,
  VINC_PREST_OPTIONS,
  MEC_AF_COMEX_P_OPTIONS,
  MEC_AF_COMEX_T_OPTIONS,
  MOV_TEMP_BENS_OPTIONS,
  MDIC_OPTIONS,
  C_NAO_NIF_OPTIONS,
  MOEDAS_SUGERIDAS,
  MD_PRESTACAO_VALUES,
  VINC_PREST_VALUES,
  MEC_AF_COMEX_P_VALUES,
  MEC_AF_COMEX_T_VALUES,
  MOV_TEMP_BENS_VALUES,
  MDIC_VALUES,
  C_NAO_NIF_VALUES,
} from "@/data/nfse/comExt";
import api, { publicApi } from "@/services/api";
import {
  searchMunicipios,
  getErrorMessage,
  resolveIssueError,
  isNfseServiceIncomplete,
} from "@/utils/nfseHelpers";
import { useToast } from "vue-toastification";

const toast = useToast();

function todayLocalISODate() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

const TOT_TRIB_MODES = ["pTotTribSN", "pTotTrib", "indTotTrib"];

const TP_IMUNIDADE_OPTIONS = [
  {
    value: "1",
    label: "Patrimônio, renda ou serviços de entes públicos (União, Estados, DF e Municípios)",
  },
  { value: "2", label: "Templos de qualquer culto" },
  {
    value: "3",
    label:
      "Partidos políticos e suas fundações, entidades sindicais de trabalhadores, instituições de educação e de assistência social sem fins lucrativos",
  },
  {
    value: "4",
    label: "Livros, jornais, periódicos e o papel destinado a sua impressão",
  },
  {
    value: "5",
    label: "Fonogramas e videofonogramas musicais produzidos no Brasil",
  },
];

const TP_IMUNIDADE_VALUES = TP_IMUNIDADE_OPTIONS.map((option) => option.value);

// Campos de país só existem para partes no exterior — endereço no Brasil usa
// município/UF, então "BR" nunca é uma opção válida aqui.
const PAISES_EXTERIOR = paises.filter((p) => p.codigo !== "BR");

// Os padrões abaixo são as respostas neutras do grupo ("nenhum mecanismo de
// apoio", "sem vínculo", "sem movimentação de bens"); o que depende da
// operação — modo de prestação, moeda e valor — começa vazio.
function emptyComExt() {
  return {
    mdPrestacao: "",
    vincPrest: "0",
    tpMoeda: "",
    vServMoeda: "",
    mecAFComexP: "01",
    mecAFComexT: "01",
    movTempBens: "1",
    mdic: "1",
    nDI: "",
    nRE: "",
  };
}

export default {
  name: "nfse-issue",
  data() {
    return {
      loaderActive: false,
      configLoaded: false,
      configActive: null,
      totTribMode: undefined,
      regEspTrib: "0",
      legacyTotTrib: null,
      submitError: null,
      tpImunidadeError: "",
      tpImunidadeOptions: TP_IMUNIDADE_OPTIONS,
      mdPrestacaoOptions: MD_PRESTACAO_OPTIONS,
      vincPrestOptions: VINC_PREST_OPTIONS,
      mecAFComexPOptions: MEC_AF_COMEX_P_OPTIONS,
      mecAFComexTOptions: MEC_AF_COMEX_T_OPTIONS,
      movTempBensOptions: MOV_TEMP_BENS_OPTIONS,
      mdicOptions: MDIC_OPTIONS,
      cNaoNIFOptions: C_NAO_NIF_OPTIONS,
      moedasSugeridas: MOEDAS_SUGERIDAS,
      paisesExterior: PAISES_EXTERIOR,
      proximoNDps: null,
      loadingServices: true,
      loadingCustomers: true,
      loadingCep: false,
      services: [],
      customers: [],
      autoFilledValorServico: "",
      autoFilledXDescServ: "",
      sourceError: "",
      tomadorMode: "cadastrado",
      tomadorLocal: "nacional",
      tomadorIdMode: "nif",
      selectedPaisTomador: null,
      selectedPaisResultado: null,
      selectedMoeda: null,
      moedaManual: false,
      selectedMunicipioEmissao: null,
      municipioEmissaoSearch: "",
      selectedMunicipioPrestacao: null,
      municipioPrestacaoSearch: "",
      selectedMunicipioTomador: null,
      municipioTomadorSearch: "",
      model: {
        serviceItemId: "",
        xDescServ: "",
        serie: "1",
        dCompet: todayLocalISODate(),
        valores: {
          valorServico: "",
          tribISSQN: "1",
          tpImunidade: "",
          tpRetISSQN: "",
          pTotTribSN: "",
          pTotTribFed: "",
          pTotTribEst: "",
          pTotTribMun: "",
        },
        comExt: emptyComExt(),
        customerId: "",
        tomador: {
          documento: "",
          nif: "",
          cNaoNIF: "",
          nome: "",
          email: "",
          fone: "",
          endereco: {
            logradouro: "",
            numero: "",
            complemento: "",
            bairro: "",
            cep: "",
            codigoPostal: "",
            cidade: "",
            estadoProvinciaRegiao: "",
          },
        },
      },
    };
  },
  computed: {
    filteredMunicipiosEmissao() {
      return searchMunicipios(municipios, this.municipioEmissaoSearch);
    },
    filteredMunicipiosPrestacao() {
      return searchMunicipios(municipios, this.municipioPrestacaoSearch);
    },
    filteredMunicipiosTomador() {
      return searchMunicipios(municipios, this.municipioTomadorSearch);
    },
    pageTitle() {
      if (!this.$route.params.sourceId) return "Emitir NFS-e";
      return this.sourceError ? "Corrigir NFS-e" : "Duplicar NFS-e";
    },
    showTotTribSN() {
      return this.totTribMode === "pTotTribSN";
    },
    showTotTribBreakdown() {
      return this.totTribMode === "pTotTrib";
    },
    isMeiTotTrib() {
      return this.totTribMode === "indTotTrib";
    },
    configIncomplete() {
      return this.totTribMode === null;
    },
    // Imunidade, exportação e não incidência exigem empresa sem regime especial
    // de tributação — o backend rejeita as combinações conflitantes.
    allowTribIssqnEspecial() {
      return this.regEspTrib === "0";
    },
    tributacaoIndisponivelMessage() {
      if (this.allowTribIssqnEspecial) return "";
      return "Indisponível: a empresa está configurada com regime especial de tributação.";
    },
    isImunidade() {
      return this.model.valores.tribISSQN === "2";
    },
    isExportacao() {
      return this.model.valores.tribISSQN === "3";
    },
    isNaoIncidencia() {
      return this.model.valores.tribISSQN === "4";
    },
    isTribIssqnSemRetencao() {
      return this.isImunidade || this.isExportacao || this.isNaoIncidencia;
    },
    tribIssqnLabel() {
      if (this.isImunidade) return "Imunidade";
      if (this.isExportacao) return "Exportação de serviço";
      if (this.isNaoIncidencia) return "Não incidência";
      return "Tributável";
    },
    tomadorExterior() {
      return this.tomadorMode === "avulso" && this.tomadorLocal === "exterior";
    },
    // comExt não é exclusivo da exportação: qualquer parte no exterior o exige,
    // mesmo numa operação tributável.
    showComExt() {
      return this.isExportacao || this.tomadorExterior;
    },
    comExtMotivo() {
      if (this.isExportacao) return "exportação de serviço";
      return "tomador no exterior";
    },
    movTempBensComDI() {
      return this.model.comExt.movTempBens === "2";
    },
    movTempBensComRE() {
      return this.model.comExt.movTempBens === "3";
    },
    canIssue() {
      return this.configLoaded && this.configActive !== false && !this.configIncomplete;
    },
    hasIncompleteService() {
      return this.services.some((s) => this.isServiceIncomplete(s));
    },
    submitErrorCta() {
      if (!this.submitError || !this.submitError.action) return null;
      if (this.submitError.action === "config") {
        return { label: "Abrir configuração fiscal", to: "/cliente/nfse/config" };
      }
      return {
        label: "Completar cadastro do serviço",
        to: this.model.serviceItemId
          ? `/cliente/nfse/servicos/editar/${this.model.serviceItemId}`
          : "/cliente/nfse/servicos",
      };
    },
  },
  watch: {
    "model.serviceItemId"(serviceId) {
      this.applyServiceDefaults(serviceId);
    },
    // Imunidade, exportação e não incidência só admitem ISSQN não retido. Os
    // campos dependentes não podem sobreviver à troca para outra tributação.
    "model.valores.tribISSQN"(value) {
      if (["2", "3", "4"].includes(value)) this.model.valores.tpRetISSQN = "1";
      if (value !== "2") {
        this.model.valores.tpImunidade = "";
        this.tpImunidadeError = "";
      }
      if (value !== "3") {
        this.selectedPaisResultado = null;
      }
    },
    "model.valores.tpImunidade"() {
      this.tpImunidadeError = "";
    },
    // Sem gatilho ativo, comExt volta ao estado inicial para não ser enviado.
    showComExt(visible) {
      if (!visible) {
        this.model.comExt = emptyComExt();
        this.selectedMoeda = null;
        this.moedaManual = false;
      }
    },
    selectedMoeda(m) {
      this.model.comExt.tpMoeda = m ? m.numerico : "";
    },
    // nDI só existe com Declaração de Importação; nRE, com Declaração de
    // Exportação. Sem movimentação de bens, nenhum dos dois.
    "model.comExt.movTempBens"(value) {
      if (value !== "2") this.model.comExt.nDI = "";
      if (value !== "3") this.model.comExt.nRE = "";
    },
    // Cliente cadastrado é sempre nacional — o cadastro não guarda NIF nem
    // endereço no exterior.
    tomadorMode(mode) {
      if (mode === "cadastrado") this.tomadorLocal = "nacional";
    },
    // Nunca enviar os dois conjuntos de identificação/endereço juntos.
    tomadorLocal(local) {
      if (local === "exterior") {
        this.model.tomador.documento = "";
        this.model.tomador.endereco.cep = "";
        this.selectedMunicipioTomador = null;
      } else {
        this.model.tomador.nif = "";
        this.model.tomador.cNaoNIF = "";
        this.model.tomador.endereco.codigoPostal = "";
        this.model.tomador.endereco.cidade = "";
        this.model.tomador.endereco.estadoProvinciaRegiao = "";
        this.selectedPaisTomador = null;
      }
    },
    tomadorIdMode(mode) {
      if (mode === "nif") this.model.tomador.cNaoNIF = "";
      else this.model.tomador.nif = "";
    },
    // A config chega depois do mount; se a empresa tem regime especial, as
    // tributações não tributáveis deixam de existir.
    allowTribIssqnEspecial(allowed) {
      if (!allowed && this.isTribIssqnSemRetencao) {
        this.model.valores.tribISSQN = "1";
      }
    },
  },
  async mounted() {
    await Promise.all([
      this.loadNfseConfig(),
      this.loadServices(),
      this.loadCustomers(),
    ]);

    if (this.$route.params.sourceId) {
      await this.hydrateFromSource(this.$route.params.sourceId);
    }

    this.$nextTick(() => {
      this.$el.querySelectorAll(".vs__search").forEach((el) => {
        el.setAttribute("autocomplete", "nfse-municipio");
      });
    });
  },
  methods: {
    async loadNfseConfig() {
      try {
        const { data } = await api.get("/company/nfse/config");
        if (data) {
          this.configActive = data.is_active ?? false;
          this.totTribMode = TOT_TRIB_MODES.includes(data.tot_trib_mode)
            ? data.tot_trib_mode
            : null;
          this.proximoNDps = data.proximo_n_dps ?? null;
          this.regEspTrib =
            data.reg_esp_trib != null ? String(data.reg_esp_trib) : "0";
          if (data.c_loc_emi) {
            this.selectedMunicipioEmissao =
              municipios.find((m) => m.codigo === String(data.c_loc_emi)) || null;
          }
          if (data.serie) {
            this.model.serie = data.serie;
          }
        } else {
          this.configActive = false;
          this.totTribMode = null;
        }
      } catch {
        this.configActive = false;
        this.totTribMode = null;
      } finally {
        this.configLoaded = true;
      }
    },
    async hydrateFromSource(sourceId) {
      try {
        const { data } = await api.get(`/company/nfse/${sourceId}`);
        const req = data.request_json || {};
        this.sourceError = data.last_error || "";

        if (req.serie != null) this.model.serie = String(req.serie);
        if (req.dCompet) this.model.dCompet = req.dCompet;
        if (req.xDescServ) this.model.xDescServ = req.xDescServ;

        if (req.valores) {
          if (req.valores.valorServico != null) {
            this.model.valores.valorServico = String(req.valores.valorServico);
          }
          // Notas emitidas antes de tribISSQN não têm o campo: undefined é "1".
          const tribISSQN = String(req.valores.tribISSQN ?? "1");
          this.model.valores.tribISSQN =
            ["2", "3", "4"].includes(tribISSQN) && this.allowTribIssqnEspecial
              ? tribISSQN
              : "1";
          if (
            this.model.valores.tribISSQN === "2" &&
            TP_IMUNIDADE_VALUES.includes(String(req.valores.tpImunidade))
          ) {
            this.model.valores.tpImunidade = String(req.valores.tpImunidade);
          }
          if (this.model.valores.tribISSQN === "3" && req.valores.cPaisResult) {
            this.selectedPaisResultado =
              PAISES_EXTERIOR.find(
                (p) => p.codigo === String(req.valores.cPaisResult)
              ) || null;
          }
          if (req.valores.tpRetISSQN) {
            this.model.valores.tpRetISSQN = String(req.valores.tpRetISSQN);
          }
          ["pTotTribSN", "pTotTribFed", "pTotTribEst", "pTotTribMun"].forEach((key) => {
            if (req.valores[key] != null) {
              this.model.valores[key] = String(req.valores[key]);
            }
          });
          // Nota antiga (layout legado): campo único pTotTrib.
          if (req.valores.pTotTrib != null && req.valores.pTotTribSN == null) {
            if (this.totTribMode === "pTotTribSN") {
              this.model.valores.pTotTribSN = String(req.valores.pTotTrib);
            } else if (this.totTribMode === "pTotTrib") {
              this.legacyTotTrib = String(req.valores.pTotTrib);
            }
            // indTotTrib (MEI): descarta silenciosamente — não há campo a preencher.
          }
        }

        if (req.cLocEmi) {
          this.selectedMunicipioEmissao =
            municipios.find((m) => m.codigo === String(req.cLocEmi)) || null;
        }
        if (req.cLocPrestacao) {
          this.selectedMunicipioPrestacao =
            municipios.find((m) => m.codigo === String(req.cLocPrestacao)) || null;
        }

        if (req.customerId) {
          this.tomadorMode = "cadastrado";
          this.model.customerId = req.customerId;
        } else if (req.tomador) {
          this.tomadorMode = "avulso";
          const t = req.tomador;
          this.model.tomador.nome = t.nome || "";
          this.model.tomador.email = t.email || "";
          this.model.tomador.fone = t.fone || "";
          const end = t.endereco || {};
          this.model.tomador.endereco.logradouro = end.logradouro || "";
          this.model.tomador.endereco.numero = end.numero || "";
          this.model.tomador.endereco.complemento = end.complemento || "";
          this.model.tomador.endereco.bairro = end.bairro || "";
          // Notas anteriores a esta mudança nunca têm NIF nem endereço no
          // exterior — caem sempre no ramo nacional.
          if (t.nif || t.cNaoNIF || end.pais) {
            this.tomadorLocal = "exterior";
            this.tomadorIdMode = t.nif ? "nif" : "cNaoNIF";
            this.model.tomador.nif = t.nif || "";
            this.model.tomador.cNaoNIF = C_NAO_NIF_VALUES.includes(String(t.cNaoNIF))
              ? String(t.cNaoNIF)
              : "";
            this.model.tomador.endereco.codigoPostal = end.codigoPostal || "";
            this.model.tomador.endereco.cidade = end.cidade || "";
            this.model.tomador.endereco.estadoProvinciaRegiao =
              end.estadoProvinciaRegiao || "";
            if (end.pais) {
              this.selectedPaisTomador =
                PAISES_EXTERIOR.find((p) => p.codigo === String(end.pais)) || null;
            }
          } else {
            this.model.tomador.documento = t.documento || "";
            this.model.tomador.endereco.cep = end.cep || "";
            if (end.codigoMunicipio) {
              this.selectedMunicipioTomador =
                municipios.find((m) => m.codigo === String(end.codigoMunicipio)) || null;
            }
          }
        }

        // Depois do tomador: comExt só é restaurado se algum gatilho (exportação
        // ou parte no exterior) sobreviveu à hidratação.
        if (req.comExt && this.showComExt) {
          const restored = { ...emptyComExt() };
          Object.keys(restored).forEach((key) => {
            if (req.comExt[key] != null && req.comExt[key] !== "") {
              restored[key] = String(req.comExt[key]);
            }
          });
          this.model.comExt = restored;
          // A moeda restaurada pode não estar na lista curada de sugestões —
          // nesse caso cai para o campo manual em vez de ficar sem seleção.
          const moeda = MOEDAS_SUGERIDAS.find((m) => m.numerico === restored.tpMoeda);
          this.selectedMoeda = moeda || null;
          this.moedaManual = !moeda && !!restored.tpMoeda;
        }

        // Preencher valores/descrição antes do serviceItemId: o watch de F2 só
        // sobrescreve campos vazios ou herdados do auto-preenchimento anterior,
        // então os valores originais acima têm prioridade.
        if (req.serviceItemId) {
          this.model.serviceItemId = req.serviceItemId;
        }
      } catch (e) {
        toast.error(
          getErrorMessage(e, "Não foi possível carregar os dados da NFS-e original.")
        );
      }
    },
    applyServiceDefaults(serviceId) {
      const service = this.services.find((s) => s.id === serviceId);
      if (!service) return;

      if (service.default_price != null && service.default_price !== "") {
        const priceStr = String(service.default_price);
        const current = this.model.valores.valorServico;
        if (current === "" || current === this.autoFilledValorServico) {
          this.model.valores.valorServico = priceStr;
          this.autoFilledValorServico = priceStr;
        }
      }

      if (service.default_description) {
        const descStr = String(service.default_description);
        const current = this.model.xDescServ;
        if (current === "" || current === this.autoFilledXDescServ) {
          this.model.xDescServ = descStr;
          this.autoFilledXDescServ = descStr;
        }
      }
    },
    async loadServices() {
      try {
        const { data } = await api.get("/company/nfse/services");
        this.services = Array.isArray(data) ? data : (data.data || []);
      } catch {
        toast.error("Erro ao carregar serviços cadastrados.");
      } finally {
        this.loadingServices = false;
      }
    },
    serviceFiscalLabel(s) {
      return (
        (s.nbs && (s.nbs.nbs_formatted_code || s.nbs.nbs_code)) ||
        (s.classification && s.classification.ctrib_nac) ||
        "-"
      );
    },
    isServiceIncomplete(s) {
      return isNfseServiceIncomplete(s);
    },
    async loadCustomers() {
      try {
        const { data } = await api.get("/company/nfse/customers");
        this.customers = Array.isArray(data) ? data : (data.data || []);
      } catch {
        toast.error("Erro ao carregar clientes cadastrados.");
      } finally {
        this.loadingCustomers = false;
      }
    },
    onMunicipioEmissaoSearch(search) {
      this.municipioEmissaoSearch = search;
    },
    onMunicipioPrestacaoSearch(search) {
      this.municipioPrestacaoSearch = search;
    },
    onMunicipioTomadorSearch(search) {
      this.municipioTomadorSearch = search;
    },
    onlyDigits(value) {
      return String(value || "").replace(/\D/g, "");
    },
    // Alterna entre buscar a moeda por código/nome (lista curada) e digitar o
    // código numérico manualmente, para quando a moeda não está na lista.
    toggleMoedaManual(manual) {
      this.moedaManual = manual;
      if (manual) return;
      const found = this.moedasSugeridas.find(
        (m) => m.numerico === this.model.comExt.tpMoeda
      );
      this.selectedMoeda = found || null;
      if (!found) this.model.comExt.tpMoeda = "";
    },
    async onCepInput() {
      const cep = this.model.tomador.endereco.cep.replace(/\D/g, "");
      if (cep.length !== 8) return;
      try {
        this.loadingCep = true;
        const { data } = await publicApi.get(`https://viacep.com.br/ws/${cep}/json/`);
        if (data.erro) return;
        this.model.tomador.endereco.logradouro = data.logradouro || "";
        this.model.tomador.endereco.bairro = data.bairro || "";
        const found = municipios.find(
          (m) => String(m.codigo) === String(data.ibge)
        );
        if (found) this.selectedMunicipioTomador = found;
      } catch {
        // silencioso — usuário preenche manualmente se falhar
      } finally {
        this.loadingCep = false;
      }
    },
    getServiceValue() {
      return this.toDecimal(this.model.valores.valorServico);
    },
    toDecimal(raw) {
      return Number(String(raw ?? "").trim().replace(",", "."));
    },
    isPercent(raw) {
      const s = String(raw ?? "").trim().replace(",", ".");
      if (s === "") return false;
      const n = Number(s);
      return !Number.isNaN(n) && n >= 0 && n <= 100;
    },
    buildPayload() {
      const payload = {
        serviceItemId: Number(this.model.serviceItemId),
        valores: {
          valorServico: this.getServiceValue(),
          tpRetISSQN: this.model.valores.tpRetISSQN,
        },
      };

      // "1" é o padrão do backend — só enviamos quando for outra coisa.
      if (this.model.valores.tribISSQN !== "1") {
        payload.valores.tribISSQN = this.model.valores.tribISSQN;
      }

      if (this.isImunidade && this.model.valores.tpImunidade) {
        payload.valores.tpImunidade = String(this.model.valores.tpImunidade);
      }

      // Opcional, e recusado pelo backend fora da exportação.
      if (this.isExportacao && this.selectedPaisResultado?.codigo) {
        payload.valores.cPaisResult = this.selectedPaisResultado.codigo;
      }

      if (this.showComExt) {
        const c = this.model.comExt;
        payload.comExt = {
          mdPrestacao: c.mdPrestacao,
          vincPrest: c.vincPrest,
          tpMoeda: c.tpMoeda.trim(),
          vServMoeda: this.toDecimal(c.vServMoeda),
          mecAFComexP: c.mecAFComexP,
          mecAFComexT: c.mecAFComexT,
          movTempBens: c.movTempBens,
          mdic: c.mdic,
        };
        // nDI e nRE são proibidos quando não há movimentação de bens.
        if (this.movTempBensComDI) payload.comExt.nDI = c.nDI.trim();
        if (this.movTempBensComRE) payload.comExt.nRE = c.nRE.trim();
      }

      if (this.model.serie.trim()) {
        payload.serie = this.model.serie.trim();
      }

      if (this.model.dCompet) {
        payload.dCompet = this.model.dCompet;
      }

      if (this.selectedMunicipioEmissao?.codigo) {
        payload.cLocEmi = String(this.selectedMunicipioEmissao.codigo);
      }

      if (this.selectedMunicipioPrestacao?.codigo) {
        payload.cLocPrestacao = String(this.selectedMunicipioPrestacao.codigo);
      }

      const xDescServ = this.model.xDescServ.trim();
      if (xDescServ) {
        payload.xDescServ = xDescServ;
      }

      if (this.totTribMode === "pTotTribSN") {
        payload.valores.pTotTribSN = this.toDecimal(this.model.valores.pTotTribSN);
      } else if (this.totTribMode === "pTotTrib") {
        payload.valores.pTotTribFed = this.toDecimal(this.model.valores.pTotTribFed);
        payload.valores.pTotTribEst = this.toDecimal(this.model.valores.pTotTribEst);
        payload.valores.pTotTribMun = this.toDecimal(this.model.valores.pTotTribMun);
      }

      if (this.tomadorMode === "cadastrado") {
        payload.customerId = Number(this.model.customerId);
      } else {
        payload.tomador = {
          nome: this.model.tomador.nome.trim(),
          endereco: {
            logradouro: this.model.tomador.endereco.logradouro.trim(),
            numero: this.model.tomador.endereco.numero.trim(),
            bairro: this.model.tomador.endereco.bairro.trim(),
          },
        };

        // Identificação e endereço são escolhas excludentes: nacional
        // (CPF/CNPJ + município) ou exterior (NIF/cNaoNIF + país).
        if (this.tomadorExterior) {
          if (this.tomadorIdMode === "nif") {
            payload.tomador.nif = this.model.tomador.nif.trim();
          } else {
            payload.tomador.cNaoNIF = this.model.tomador.cNaoNIF;
          }
          Object.assign(payload.tomador.endereco, {
            pais: this.selectedPaisTomador?.codigo ?? "",
            codigoPostal: this.model.tomador.endereco.codigoPostal.trim(),
            cidade: this.model.tomador.endereco.cidade.trim(),
            estadoProvinciaRegiao:
              this.model.tomador.endereco.estadoProvinciaRegiao.trim(),
          });
        } else {
          payload.tomador.documento = this.onlyDigits(this.model.tomador.documento);
          Object.assign(payload.tomador.endereco, {
            codigoMunicipio: this.selectedMunicipioTomador?.codigo ?? "",
            uf: this.selectedMunicipioTomador?.uf ?? "",
            cep: this.onlyDigits(this.model.tomador.endereco.cep),
          });
        }

        const email = this.model.tomador.email.trim();
        if (email) payload.tomador.email = email;

        const fone = this.onlyDigits(this.model.tomador.fone);
        if (fone) payload.tomador.fone = fone;

        const complemento = this.model.tomador.endereco.complemento.trim();
        if (complemento) payload.tomador.endereco.complemento = complemento;
      }

      return payload;
    },
    validateForm(payload) {
      if (!payload.serviceItemId || Number.isNaN(payload.serviceItemId)) {
        toast.error("Selecione um serviço.");
        return false;
      }

      if (
        Number.isNaN(payload.valores.valorServico) ||
        payload.valores.valorServico < 0.01 ||
        payload.valores.valorServico > 9999999.99
      ) {
        toast.error("Informe um valor de serviço entre 0.01 e 9999999.99.");
        return false;
      }

      if (!["1", "2", "3", "4"].includes(this.model.valores.tribISSQN)) {
        toast.error("Selecione a tributação do ISSQN.");
        return false;
      }

      if (this.isTribIssqnSemRetencao && !this.allowTribIssqnEspecial) {
        toast.error(this.tributacaoIndisponivelMessage);
        return false;
      }

      if (
        this.isImunidade &&
        !TP_IMUNIDADE_VALUES.includes(this.model.valores.tpImunidade)
      ) {
        this.tpImunidadeError = "Selecione o tipo de imunidade.";
        toast.error(this.tpImunidadeError);
        return false;
      }

      if (!["1", "2", "3"].includes(payload.valores.tpRetISSQN)) {
        toast.error("Selecione o tipo de retenção do ISSQN.");
        return false;
      }

      if (this.isTribIssqnSemRetencao && payload.valores.tpRetISSQN !== "1") {
        toast.error(`${this.tribIssqnLabel} do ISSQN não admite retenção.`);
        return false;
      }

      if (this.totTribMode === "pTotTribSN" && !this.isPercent(this.model.valores.pTotTribSN)) {
        toast.error("Informe a alíquota total de tributos entre 0 e 100.");
        return false;
      }

      if (this.totTribMode === "pTotTrib") {
        const campos = [
          ["pTotTribFed", "federais"],
          ["pTotTribEst", "estaduais"],
          ["pTotTribMun", "municipais"],
        ];
        for (const [key, label] of campos) {
          if (!this.isPercent(this.model.valores[key])) {
            toast.error(`Informe o percentual de tributos ${label} entre 0 e 100.`);
            return false;
          }
        }
      }

      if (this.showComExt && !this.validateComExt(payload.comExt)) {
        return false;
      }

      if (this.tomadorMode === "cadastrado") {
        if (!payload.customerId || Number.isNaN(payload.customerId)) {
          toast.error("Selecione um cliente.");
          return false;
        }
        return true;
      }

      if (!payload.tomador.nome) {
        toast.error("Informe o nome do tomador.");
        return false;
      }

      if (!payload.tomador.endereco.logradouro) {
        toast.error("Informe o logradouro do tomador.");
        return false;
      }

      if (!payload.tomador.endereco.numero) {
        toast.error("Informe o número do endereço do tomador.");
        return false;
      }

      if (!payload.tomador.endereco.bairro) {
        toast.error("Informe o bairro do tomador.");
        return false;
      }

      if (this.tomadorExterior) {
        return this.validateTomadorExterior(payload.tomador);
      }

      if (
        ![11, 14].includes(payload.tomador.documento.length) ||
        !/^\d+$/.test(payload.tomador.documento)
      ) {
        toast.error("O CPF/CNPJ do tomador deve conter 11 ou 14 dígitos.");
        return false;
      }

      if (!this.selectedMunicipioTomador) {
        toast.error("Selecione o município do tomador.");
        return false;
      }

      if (!/^\d{5}-?\d{3}$/.test(payload.tomador.endereco.cep)) {
        toast.error("O CEP deve estar no formato 00000-000 ou 00000000.");
        return false;
      }

      return true;
    },
    validateComExt(comExt) {
      const selects = [
        [comExt.mdPrestacao, MD_PRESTACAO_VALUES, "o modo de prestação"],
        [comExt.vincPrest, VINC_PREST_VALUES, "o vínculo com o prestador"],
        [
          comExt.mecAFComexP,
          MEC_AF_COMEX_P_VALUES,
          "o mecanismo de apoio do prestador",
        ],
        [
          comExt.mecAFComexT,
          MEC_AF_COMEX_T_VALUES,
          "o mecanismo de apoio do tomador",
        ],
        [comExt.movTempBens, MOV_TEMP_BENS_VALUES, "o movimento temporário de bens"],
        [comExt.mdic, MDIC_VALUES, "o compartilhamento com o MDIC"],
      ];

      for (const [value, allowed, label] of selects) {
        if (!allowed.includes(value)) {
          toast.error(`Selecione ${label} nos dados de comércio exterior.`);
          return false;
        }
      }

      if (!/^\d{3}$/.test(comExt.tpMoeda)) {
        toast.error("Informe o código de 3 dígitos da moeda estrangeira.");
        return false;
      }

      if (
        Number.isNaN(comExt.vServMoeda) ||
        comExt.vServMoeda < 0.01 ||
        comExt.vServMoeda > 9999999.99
      ) {
        toast.error(
          "Informe o valor do serviço na moeda estrangeira entre 0.01 e 9999999.99."
        );
        return false;
      }

      if (this.movTempBensComDI && !comExt.nDI) {
        toast.error("Informe o número da Declaração de Importação.");
        return false;
      }

      if (this.movTempBensComRE && (comExt.nRE || "").length !== 12) {
        toast.error("O número da Declaração de Exportação deve ter 12 caracteres.");
        return false;
      }

      return true;
    },
    validateTomadorExterior(tomador) {
      if (this.tomadorIdMode === "nif") {
        if (!tomador.nif) {
          toast.error("Informe o NIF do tomador no exterior.");
          return false;
        }
      } else if (!C_NAO_NIF_VALUES.includes(tomador.cNaoNIF)) {
        toast.error("Selecione o motivo de ausência de NIF.");
        return false;
      }

      if (!this.selectedPaisTomador) {
        toast.error("Selecione o país do tomador.");
        return false;
      }

      if (!tomador.endereco.codigoPostal) {
        toast.error("Informe o código postal do tomador no exterior.");
        return false;
      }

      if (!tomador.endereco.cidade) {
        toast.error("Informe a cidade do tomador no exterior.");
        return false;
      }

      if (!tomador.endereco.estadoProvinciaRegiao) {
        toast.error("Informe o estado/província/região do tomador no exterior.");
        return false;
      }

      return true;
    },
    async submitForm() {
      this.submitError = null;

      if (!this.canIssue) {
        toast.error("A configuração fiscal da NFS-e precisa ser concluída antes de emitir.");
        return;
      }

      const payload = this.buildPayload();
      if (!this.validateForm(payload)) return;

      try {
        this.loaderActive = true;
        await api.post("/company/nfse/issue", payload);
        toast.success("Emissão da NFS-e iniciada com sucesso.");
        this.$router.push("/cliente/nfse");
      } catch (e) {
        const resolved = resolveIssueError(
          e,
          "Ocorreu um erro ao emitir a NFS-e. Verifique os dados e tente novamente."
        );
        this.submitError = resolved;
        if (resolved.code === "E_NFSE_TPIMUNIDADE_REQUIRED") {
          this.tpImunidadeError = resolved.message;
        }
        toast.error(resolved.message);
      } finally {
        this.loaderActive = false;
      }
    },
  },
};
</script>
